export const LOCALES_FIELD_NAME = 'locale';
